export default __webpack_public_path__ + "static/gs-ce37736774d52cf116744557ca7f6ca8.svg";